import React from 'react'
import PrivacyPolicy from '../privacy-policy'

const PrivacyPolicyEs = () => {
    return <PrivacyPolicy languageCode="es" />
}

export default PrivacyPolicyEs
